import {COLORS, roundDataSet} from "../utils/ChartFormatUtils";
import {
    gradientBorderColor,
    gradientFiller
} from "../utils/ChartStylingUtils";

export function assembleChartData(data) {
    return {
        labels: data.labels,
        datasets: [
            {
                yAxisID: 'waterLevel',
                data: data.waterLevels,
                label: 'Poziom wody',
                order: 2,

                //--- styling ---
                borderColor: COLORS.chartColorMain,
                pointRadius: null,
                fill: true,
                backgroundColor: gradientFiller
            },

            {
                yAxisID: 'temperature',
                data: roundDataSet(data.temperatures),
                label: 'Temperatura wody',
                order: 1,

                //--- styling ---
                borderColor: gradientBorderColor,
                pointRadius: null
            }
        ]
    }
}